"use client";

import React from "react";
import { Mail, MapPin, MessageCircle, Phone, Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const CONTACT_DATA = {
  phone: "+7 (995) 305-79-51",
  email: "advokat@kondrashov.ru",
  address: "г. Калуга, ул. Кирова, д. 2"
};
const MESSENGERS = [{
  name: "Парковка",
  icon: MessageCircle,
  description: "Для клиентов предусмотрена парковка со стороны ул. Кирова.",
  link: "#"
}, {
  name: "Транспорт",
  icon: Send,
  description: "Остановка «Улица Кирова» или «Площадь\xA0 Мира». Маршруты: 1, 2, 3, 4, 5.",
  link: "#"
}];
export default function ContactUs() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="124261" id="расположение-офиса" className="bg-background text-foreground relative overflow-hidden py-16 md:py-24 lg:py-32">
      {}
      <div className="bg-primary/5 absolute top-0 right-0 -mr-20 -mt-20 size-96 rounded-full blur-3xl" />
      <div className="bg-primary/5 absolute bottom-0 left-0 -ml-20 -mb-20 size-96 rounded-full blur-3xl" />

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-24 items-center">
          {}
          <div ref={leftRef} className={`flex flex-col space-y-10 transition-all duration-1000 ease-out ${isLeftVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <div className="space-y-4">
              <h2 className="text-foreground font-serif text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
                Расположение офиса
              </h2>
              <p className="text-secondary font-sans text-lg md:text-xl max-w-md">Адвокатский кабинет Николая Кондрашова находится в историческом центре Калуги. Реестровый номер адвоката № 40/806 в реестре адвокатов Калужской области</p>
            </div>

            <div className="flex flex-col space-y-8">
              {}
              <div className="group flex items-start gap-5">
                <div className="bg-primary/10 text-primary flex size-14 shrink-0 items-center justify-center rounded-lg transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                  <Phone className="size-7" />
                </div>
                <div className="flex flex-col">
                  <span className="text-secondary mb-1 text-sm font-medium uppercase tracking-wider font-sans">
                    Телефон
                  </span>
                  <Link to={`tel:${CONTACT_DATA.phone.replace(/[^0-9+]/g, "")}`} className="text-foreground hover:text-primary text-3xl font-semibold tracking-tight transition-colors md:text-4xl font-serif">
                    {CONTACT_DATA.phone}
                  </Link>
                </div>
              </div>

              {}
              <div className="group flex items-start gap-5">
                <div className="bg-primary/10 text-primary flex size-14 shrink-0 items-center justify-center rounded-lg transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                  <Mail className="size-7" />
                </div>
                <div className="flex flex-col">
                  <span className="text-secondary mb-1 text-sm font-medium uppercase tracking-wider font-sans">
                    Email
                  </span>
                  <Link to={`mailto:${CONTACT_DATA.email}`} className="text-foreground hover:text-primary text-2xl font-medium transition-colors md:text-3xl font-sans">lawhelpklg@gmail.com</Link>
                </div>
              </div>

              {}
              <div className="group flex items-start gap-5">
                <div className="bg-primary/10 text-primary flex size-14 shrink-0 items-center justify-center rounded-lg transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                  <MapPin className="size-7" />
                </div>
                <div className="flex flex-col">
                  <span className="text-secondary mb-1 text-sm font-medium uppercase tracking-wider font-sans">
                    Адрес кабинета
                  </span>
                  <span className="text-foreground text-xl md:text-2xl font-sans">г. Калуга, ул. Кирова, д. 2, оф. 701, 7 этаж</span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col gap-6 transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            {MESSENGERS.map((messenger, index) => {
            const Icon = messenger.icon;
            return <Card key={messenger.name} data-index={index} className="border-border/50 bg-card/80 shadow-xl backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl rounded-lg">
                  <CardHeader className="flex flex-row items-center gap-5 pb-4">
                    <div className="bg-primary/10 text-primary flex size-16 shrink-0 items-center justify-center rounded-lg">
                      <Icon className="size-8" />
                    </div>
                    <div className="space-y-1">
                      <CardTitle className="text-2xl font-bold font-serif">
                        {messenger.name}
                      </CardTitle>
                      <CardDescription className="text-secondary text-base font-sans">
                        {messenger.description}
                      </CardDescription>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 h-14 w-full text-lg font-medium shadow-md rounded-lg">
                      <Link to={messenger.link} newTab>
                        Проложить маршрут
                      </Link>
                    </Button>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}